module.exports = __webpack_public_path__ + "assets/img/img_2012.b09aa7f8.jpg";